// extracted by mini-css-extract-plugin
export default {"container":"StoreBanner_container__3dJ4T","bannerImage":"StoreBanner_bannerImage__zV+Y9"};